<template>
    <div>
        <h2>請選擇 {{ this.child_num }} 份商品</h2>
        <div v-for="item, index in child_list">
            <div class="form_name">{{ item.form_name }}</div>
            <div class="number">
                <button type="button" class="btn iconfont" @click="decrement(index)">-
                </button>
                <input type="number" name="quantity" @input="validateInput(index)" v-model="item.display_num"
                    class="border-0 text-center w-100   p-0" data-max="1" data-min="1">
                <button type="button" class="btn iconfont" @click="increment(index)">+
                </button>
            </div>
        </div>
        <div class="btn">
            <button @click="checkChild_list">確認</button>
        </div>

    </div>
</template>
<script>
import Vue from 'vue';
import { Dialog } from 'element-ui';
import { mapState } from 'vuex';
Vue.use(Dialog);
export default {
    props: ['child_list', 'centerDialogVisible', 'child_num', 'list_num', 'list_itemid'],
    components: {},
    data() {
        return {
            // centerDialogVisible: false,
            //子商品
            // child_list: [],
            // child_num: '',
            parm: [],
            num: this.list_num
        };
    },
    computed: {
        totalSum() {
            return this.child_list.reduce((sum, item) => sum + item.display_num, 0);
        },
        ...mapState('cart', ['cart_list_item'])
    },
    watch: {},
    methods: {
        increment(index) {
            if (this.totalSum < this.child_num) {
                this.child_list[index].display_num++;
            }
        },
        validateInput(index) {
            // 确保当前输入是一个有效数字
            this.child_list[index].display_num = Math.max(0, parseInt(this.child_list[index].display_num) || 0);

            // 计算所有 display_num 的总和
            let total = this.child_list.reduce((sum, item) => sum + item.display_num, 0);

            // 如果总和超过 child_num，则减少当前输入的值
            if (total > this.child_num) {
                let excess = total - this.child_num;
                this.child_list[index].display_num = Math.max(0, this.child_list[index].display_num - excess);
            }
        },
        decrement(index) {
            if (this.child_list[index].display_num > 0) {
                this.child_list[index].display_num--;
            }
        },
        checkChild_list() {
            let number = 0
            this.parm = this.child_list.map(item => {
                number += item.display_num
                return {
                    item: item.isubid,
                    num: item.display_num
                };
            });
            if (this.cart_list_item.length != 0) {
                this.cart_list_item.forEach(element => {
                    if (this.list_itemid == element.item_id) {
                        this.num += element.num
                        element.sub.forEach(sub_item => {
                            const existingItem = this.parm.find(item1 => item1.item === sub_item.isubid);
                            if (existingItem) {
                                // 如果存在，则将数量相加
                                existingItem.num += sub_item.num;
                            }
                        });
                    }
                });
            }
            if (number == this.child_num) {
                this.$emit('dialog_close', { parm: this.parm, number: this.num });
            } else {
                this.$notify({
                    title: `數量選擇有錯哦! 您可以選 ${this.child_num} 樣商品^_^`,
                    type: 'warning'
                });
            }
        },

    },
    created() {
    },
    mounted() {
    },
}
</script>
<style lang='scss' scoped>

</style>